import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { ImageWithModal } from '../common';

const photos = [
  'fundacion/Imagen1.jpg',
  'fundacion/Imagen2.jpg',
  'fundacion/Imagen3.jpg',
  'fundacion/Imagen4.jpg',
  'fundacion/Imagen5.jpg',
  'fundacion/Imagen6.jpg',
  'fundacion/Imagen7.jpg',
  'fundacion/Imagen8.jpg',
  'fundacion/Imagen9.jpg',
  'fundacion/Imagen10.jpg',
  'fundacion/Imagen11.jpg',
  'fundacion/Imagen12.jpg',
  'fundacion/Imagen13.jpg',
  'fundacion/Imagen14.jpg',
  'fundacion/Imagen15.jpg',
  'fundacion/Imagen16.jpg',
  'fundacion/Imagen17.jpg',
  'fundacion/Imagen18.jpg',
  'fundacion/Imagen19.jpg',
];

const founders = [
  { name: 'Dra. Adalsa Hernández', charge: 'Presidente' },
  { name: 'Dr. Justo Bonomie', charge: 'Vicepresidente' },
  { name: 'Dra. Maira Quevedo Piña', charge: 'Secretaria' },
  { name: 'Dr. Bruno Pier Doménico', charge: 'Secretario de Organización' },
  { name: 'Dr. Juan Carlos Martínez Gómez', charge: 'Tesorero' },
  { name: 'Dr. Francisco Penella', charge: 'Vocal' },
  { name: 'Dr. John Luna', charge: 'Vocal' },
];

export default function About() {
  return (
    <div className="bg-gray-100 w-full px-8">
      <div className="max-w-7xl my-16 text-justify">
        <div className="flex flex-row flex-wrap w-full">
          <div className="w-full lg:w-1/3 px-4 flex mb-4">
            <StaticImage
              alt="Quienes Somos"
              src="../../images/quienes-somos-1.jpg"
              className="w-full h-auto shadow-2xl m-auto rounded-lg"
            />
          </div>
          <div className="w-full lg:w-2/3 px-4">
            <h3 className="text-2xl font-semibold">Fundación</h3>
            <p className="mt-4">
              El día 8 de Noviembre de 2012, previo a la aprobación por parte
              del Colegio de Odontólogos de Venezuela, al mismo tiempo que se
              celebraba 117 años del descubrimiento de los Rayos X por parte de
              Wilhelm Conrad Roentgen, se firmó el acta de constitución de la
              Sociedad Venezolana de Radiología e Imagenología
              Dentomaxilofacial. Con mucho entusiasmo y deseosos de contribuir
              con la difusión de normas y leyes que rigen el ejercicio de esta
              especialidad, así como también difundir conocimientos actualizados
              para el mejor ejercicio de la misma. Participaron ën este acto,
              entre otras personalidades notables de la Odontología, la Decana
              de la Facultad de Odontología de la Universidad de Carabobo, Dra.
              Yngrid Acosta y el Dr. Justo Bonomie, Decano de la Facultad de
              Odontología de la Universidad de los Andes. La Junta Directiva
              encargada de regir los destinos de la naciente Sociedad de
              Radiología e Imagenología Dentomaxilofacial estuvo constituida
              por:
            </p>
            <div className="my-8 max-w-6xl mx-auto">
              <table className="w-full text-center px-4 py-6">
                <thead>
                  <tr className="border-b-2 border-blue-700">
                    <th className="px-3 py-2 font-lg">Nombre</th>
                    <th className="px-3 py-2 font-lg">Cargo</th>
                  </tr>
                </thead>
                <tbody>
                  {founders.map(({ name, charge }) => (
                    <tr className="border-t border-blue-700" key={name}>
                      <td className="px-4 py-2 text-left">{name}</td>
                      <td className="px-4 py-2 ">{charge}</td>{' '}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl my-16 text-justify">
        <div className="flex flex-row flex-wrap w-full justify-evenly">
          <div className="max-w-md w-full p-6 flex flex-col flex-wrap mb-4">
            <div className="w-full flex h-auto flex-row flex-wrap justify-center">
              <svg
                className="w-8 h-8 fill-current text-blue-700 my-auto mr-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 499.84 499.84"
              >
                <path d="M344.64 72.64l-192-64L9.92 80v419.84L155.2 427.2l192 64 142.72-71.36V0L344.64 72.64zM457.92 400l-113.28 56.64-174.72-58.24V89.92l-32 16V400l-96 48V99.84L155.2 43.2l174.72 58.24v308.48l32-16V99.84l96-48V400z" />
              </svg>
              <h3 className="text-center text-xl font-semibold">Misión</h3>
            </div>
            <p className="mt-4">
              Promover y estimular el desarrollo de la Radiología e Imagenología
              Dentomaxilofacial en el país.
            </p>
          </div>
          <div className="max-w-md w-full p-6 flex flex-col flex-wrap mb-4">
            <div className="w-full flex h-auto flex-row flex-wrap justify-center">
              <svg
                className="w-8 h-8 fill-current text-blue-700 my-auto mr-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 511.999 511.999"
              >
                <path d="M507.134 182.136C461.335 138.4 367.807 65 256 65c-44.295 0-90.292 11.83-136.714 35.16-39.486 19.846-79.052 48.192-114.42 81.976-6 5.722-6.208 15.217-.486 21.208s15.218 6.208 21.208.486C97.995 134.666 181.977 95 256 95c101.345 0 187.86 68.186 230.412 108.83 2.906 2.775 6.635 4.154 10.36 4.153a14.96 14.96 0 0 0 10.85-4.64c5.722-6 5.505-15.485-.486-21.208zm1.846 96.84c-1.15-1.528-28.695-37.843-73.236-74.55-26.33-21.7-53.182-39.03-79.805-51.507C322.075 137.046 288.45 129 256 129s-66.075 8.047-99.94 23.917c-26.624 12.477-53.474 29.807-79.805 51.507C31.713 241.13 4.17 277.446 3.02 278.974a15 15 0 0 0-.001 18.049c1.15 1.528 28.695 37.843 73.236 74.55 26.33 21.7 53.182 39.03 79.805 51.507C189.925 438.952 223.55 447 256 447s66.075-8.047 99.94-23.917c26.624-12.477 53.474-29.807 79.805-51.507 44.542-36.708 72.085-73.023 73.236-74.55a15 15 0 0 0 0-18.048zm-92.837 69.877C378.305 379.94 319.805 417 256 417s-122.305-37.06-160.144-68.147C66.715 324.9 44.952 300.68 34.3 288c10.664-12.684 32.425-36.913 61.566-60.854C133.695 196.057 192.195 159 256 159s122.305 37.058 160.144 68.146c29.14 23.94 50.902 48.17 61.565 60.854-10.664 12.685-32.425 36.913-61.565 60.854zM256 193c-52.383 0-95 42.617-95 95s42.617 95 95 95 95-42.617 95-95-42.617-95-95-95zm0 160c-35.84 0-65-29.16-65-65s29.16-65 65-65 65 29.16 65 65-29.16 65-65 65zm0-96c-17.093 0-31 13.907-31 31s13.907 31 31 31 31-13.907 31-31-13.907-31-31-31z" />
              </svg>
              <h3 className="text-center text-xl font-semibold">Visión</h3>
            </div>
            <p className="mt-4">
              Nuestra sociedad tiene objetivos claros y precisos entre otros:
              promover los más altos niveles técnicos y científicos de la
              Radiología e Imagenología Dentomaxilofacial en el país, auspiciar
              la investigación, divulgar información científica, velar por el
              mantenimiento de los principios éticos en el ejercicio profesional
              de sus miembros y la difusión de leyes, reglamentos y normas.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7xl my-16 text-justify">
        <div className="flex flex-row flex-wrap w-full lg:flex-row-reverse">
          <div className="w-full lg:w-1/3 flex px-4 mb-4">
            <StaticImage
              alt="Quienes Somos 2"
              src="../../images/quienes-somos-2.jpg"
              className="w-full h-auto m-auto shadow-2xl rounded-lg"
            />
          </div>
          <div className="w-full lg:w-2/3 px-4">
            <h3 className="text-2xl font-semibold">Objetivos</h3>
            <ol className="list-decimal list-inside text-justify space-y-2 mt-4">
              <li>
                Promover los más altos niveles técnicos y científicos de la
                Radiología e Imagenología Dentomaxilofacial en el país.
              </li>
              <li>
                Auspiciar la investigación en el campo de la Radiología e
                Imagenología Dentomaxilofacial e incrementar la difusión de tal
                especialidad en el país
              </li>
              <li>
                Divulgar información científica de manera continua entre los
                miembros de la Sociedad y cualquier otra persona o entidad
                pública o privada interesada en el campo de la Radiología e
                Imagenología Dentomaxilofacial.
              </li>
              <li>
                Estimular el intercambio de conocimientos entre los miembros de
                la Sociedad mediante la organización de eventos científicos y
                establecer comunicación e intercambios con otras Sociedades
                Científicas afines, tanto nacionales como extranjeras
              </li>
              <li>
                Velar por el mantenimiento de los principios éticos en el
                ejercicio profesional de sus miembros, de conformidad con el
                código de Deontología Odontológica vigente.
              </li>
              <li>
                Difundir leyes, reglamentos y normas que contribuyan al correcto
                ejercicio de la especialidad.
              </li>
              <li>
                Realizar todas las actividades que tiendan al logro del objeto
                para el cual ha sido constituida LA SOCIEDAD.
              </li>
              <li>
                Las demás que determine La Asamblea General Nacional
                expresamente convocada para ello.
              </li>
            </ol>
          </div>
          <div className="flex flex-col flex-wrap w-full p-16 bg-gray-100">
            <div className="w-full flex flex-row flex-wrap -mx-4">
              {photos.map((photo) => (
                <div
                  className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-8"
                  key={photo}
                >
                  <ImageWithModal src={photo} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
